class Music {
    filename: string;
    audio: HTMLAudioElement;
    buffer: any;
    unlocked: boolean;
    static _instance: Music;

    static get instance() {
        return Music._instance;
    }

    constructor(filename: string) {
        this.filename = filename;
        this.unlocked = false;
        this.audio = new Audio(`${window.location.origin}/${this.filename}`);
        this.audio.loop = true;
        this.audio.muted = true;
        this.audio.volume = 0.0;
        Music._instance = this;
        document.addEventListener("touchstart", this.unlockAudio.bind(this), { once: true });
        document.addEventListener("click", this.unlockAudio.bind(this), { once: true });
    }

    setVolume(volume: number) {
        const newVolume = Math.min(Math.max(volume, 0.0), 1.0);
        if (newVolume === 0.0) {
            this.audio.pause();
        } else {
            this.unlockAudio();
            this.audio.play().catch(err => {
                alert("Playback blocked until unlock:" + err);
            });
        }
        this.audio.volume = Math.min(Math.max(volume, 0.0), 1.0);
    }

    unlockAudio() {
        if (this.unlocked == false) {
            this.audio.play();
            this.audio.muted = false;
            this.audio.pause();
            this.unlocked = true;
        }
    }
}

export default Music;
